import React from "react";
import { ENQUIRY_LOGO_SRC } from "./enquiry-settings";

export const EnquiryHeader = () => (
    <header className="mb-6 overflow-hidden rounded-2xl bg-gradient-to-r from-violet-700 via-purple-600 to-indigo-600 px-6 py-8 text-white shadow-lg">
        <div className="flex flex-col items-center gap-4 md:flex-row md:items-center md:justify-between">
            <div className="flex flex-col items-center text-center md:items-start md:text-left">
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-violet-200">
                    Rajneethi
                </p>
                <h1 className="mt-1 text-2xl font-bold md:text-3xl">Enquiry Dashboard</h1>
                <p className="mt-2 max-w-xl text-sm text-violet-100">
                    Track contact form submissions from services, careers, and lead pages.
                </p>
            </div>
            <div className="rounded-2xl bg-white/95 p-4 shadow-md">
                <img
                    src={ENQUIRY_LOGO_SRC}
                    alt="Rajneethi logo"
                    className="h-16 w-auto object-contain md:h-20"
                />
            </div>
        </div>
    </header>
);
